// src/components/testimonial.tsx
"use client";

import React from "react";
import Image from "next/image";

export default function Testimonial() {
  const [active, setActive] = React.useState(1);

  return (
    <section className="py-12 px-8 lg:py-24">
      <div className="container max-w-screen-lg mx-auto">
        <div className="container mx-auto mb-20 text-center">
          <h2 className="mb-4 text-3xl lg:text-4xl font-bold text-blue-gray-900">Who&apos;s Felipe Yarns?</h2>
          <div className="mx-auto w-full px-4 lg:w-10/12 text-gray-500 leading-relaxed space-y-4">
            <p>Felipe Yarns grew up in a house where music wasn’t just a passion, it was the family language...</p>
            <p>Before stepping into the spotlight, Felipe spent years playing and recording with great Brazilian artists...</p>
            <p>Offstage, Felipe is also drawn to the world of storytelling — often writing screenplays, directing films...</p>
            <p>His music carries the soul of Brazil, the mood of R&amp;B, and the honesty of someone rediscovering who they are.</p>
          </div>
        </div>

        <div className="py-8 lg:flex lg:items-stretch lg:gap-10" id="music">
          <div className="w-full mb-10 lg:mb-0">
            <h3 className="mb-4 font-bold lg:max-w-xs text-2xl text-blue-gray-900">Solo Artist</h3>
            <p className="mb-3 w-full lg:w-8/12 font-normal text-gray-500">
              After moving to Australia the new perspective gave him room to reflect—and the idea of exploring his own sound started to take form. What began privately soon grew into a desire to share more openly.   
            </p>
            <div className="mt-4 w-full lg:w-8/12">
              <iframe
                title="Felipe Yarns – Spotify"
                src="https://open.spotify.com/embed/album/0SUtomTvKlpnm62avGHwEi"
                width="100%"
                height="80"
                frameBorder={0}
                allow="autoplay; clipboard-write; encrypted-media; fullscreen; picture-in-picture"
                loading="lazy"
                className="rounded-lg"
              />
            </div>
          </div>

          <div className="h-[21rem] rounded-lg w-full sm:w-[25rem] shrink-0 overflow-hidden">
            <Image
              width={768}
              height={768}
              alt="Felipe portrait"
              src="/image/avatar4.png"
              className="h-full w-full object-cover rounded-lg"
            />
          </div>
        </div>

        <div className="py-8 lg:flex lg:items-stretch lg:gap-10">
          <div className="w-full mb-10 lg:mb-0">
            <h3 className="mb-4 font-bold lg:max-w-xs text-2xl text-blue-gray-900">Session Musician & Sideman</h3>
            <p className="mb-3 w-full lg:w-8/12 font-normal text-gray-500">
              I had the pleasure of working with great artists such as Cleverson Silva, Ted Furtado, Bal Furtado, Braguinha, Abel Santos, Leo Maia, Gina Garcia, Jadiel Oliveira, Isabel Fillardis, and many others...
            </p>

            <div className="flex items-center gap-4" aria-label="Session photo selector">
              {[1, 2, 3, 4].map((n) => (
                <button
                  key={n}
                  type="button"
                  onClick={() => setActive(n)}
                  className={["h-9 w-9 overflow-hidden rounded-md ring-2 transition",
                    active === n ? "opacity-100 ring-blue-500" : "opacity-60 ring-transparent"
                  ].join(" ")}
                  aria-label={`Show session photo ${n}`}
                >
                  <Image src={`/image/IMG_${n}.jpg`} alt={`Session ${n}`} width={48} height={48} className="h-full w-full object-cover" />
                </button>
              ))}
            </div>
          </div>

          <div className="h-[21rem] rounded-lg w-full sm:w-[25rem] shrink-0 overflow-hidden">
            <Image
              width={768}
              height={768}
              alt={`Session image ${active}`}
              src={`/image/IMG_${active}.jpg`}
              className="h-full w-full object-cover rounded-lg"
            />
          </div>
        </div>
      </div>
    </section>
  );
}